module.exports = __webpack_public_path__ + "img/advancedSecurity.027f003.svg";